var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,19,-11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.41423,10.9459L22.71069,16.2965C23.09923,16.689,23.09601,17.322200000000002,22.7035,17.7107C22.311,18.0992,21.67784,18.096,21.28931,17.7035L15.289307,11.64218C14.9007593,11.24966,14.9039951,10.61647,15.296535,10.22795L21.29653,4.289271C21.689059999999998,3.9007574,22.32222,3.9040096,22.710729999999998,4.296535C23.09924,4.68906,23.09599,5.32222,22.70347,5.71073L17.41423,10.9459Z",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.cc1b49f52b4dccae1cbddbe64fa18f2e.svg";
export { ForwardRef as ReactComponent };